import * as tracking from '../lib/tracking'
import http from '../lib/http'
import Form from '../lib/form'
import ActiveFormFields from '../lib/activeFormFields'

window.Vue = require('vue')

const app = new Vue({
  el: '#laravel-subscribe',
  mixins: [ActiveFormFields],
  data: {
    form: new Form(),
    message: '',
    error: '',
    url: '',
    data: {}
  },
  methods: {
    onSubmit () {
      this.message = ''
      this.error = ''
      this.data = this.form.data()
      this.url = this.$refs.subscribeForm.dataset.url

      http
        .post(this.url, this.data)
        .then(response => this.onSuccess(response))
        .catch(error => this.onFail(error))
    },
    onSuccess (response) {
      tracking.send(this.$refs.subscribeForm)

      if (response.data.redirect) {
        window.location.href = response.data.redirect
      } else {
        this.message = response.data.message
      }

      this.form.reset()
    },
    onFail (error) {

      if (error.response.status === 422) {
        this.form.errors.set(error.response.data.errors)
        return
      }
      if (error.response.status === 404) {
        this.error = 'Unable to reach API'
        return
      }
      if (error.response.status === 500) {
        this.error = error.response.data.message
      }
    }
  }
})
